import React, { useEffect, useRef, useState } from "react";
import MeaPage from "../../../components/MeaPage";
import { InputText } from "primereact/inputtext";
import MeaButton from "../../../components/MeaButton";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Image } from "primereact/image";
import userAPI from "../../../services/user";
import { Toast } from "primereact/toast";
import { Password } from "primereact/password";
import { FileUpload } from "primereact/fileupload";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { FormatDateToDDMMYYYY, ParseDateFromDDMMYYYY } from "../../../utils/dates";
import AdminNotificationPreferences from "./components/AdminNotificationPreferences";

const UserProfileDetailPage = () => {
  const { account, checkAuthenticated } = useAuthContext();
  const accessToken = "";
  const [name, setName] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState(null);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const toast = useRef(null);
  const [refresh, setRefresh] = useState(Date.now());
  const [editPassword, setEditPassword] = useState(false);

  const [avatar, setAvatar] = useState(
    account?.avatar
      ? account?.avatar
      : "/user.png"
  );
  useEffect(() => {
    setFirstname(account?.firstname);
    setLastname(account?.lastname);
    setName(account?.name);
    setGender(account?.gender);
    setBirthday(account?.birthday ? ParseDateFromDDMMYYYY(account?.birthday, false)
      : null);
    setEmail(account?.email);
    setPhone(account?.phone);
    setAddress(account?.address);
    setPostalCode(account?.postal_code);
    setCity(account?.city);

    setAvatar(
      account?.avatar
        ? account?.avatar + "?" + refresh
        : "/user.png"
    );
  }, [account, refresh]);
  //
  const handleUpdateProfileSubmit = async (e) => {
    e.preventDefault();
    confirmPopup({
      target: e.currentTarget,
      message: 'Vos informations seront également modifiées dans les fiches d\'écoles dont vous faites partie. Voulez-vous vraiment continuer ?',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      rejectLabel: "Non",
      acceptLabel: "Oui",
      accept: async () => {
        await userAPI
          .UpdateUserProfile(accessToken, {
            firstname,
            lastname,
            name,
            gender,
            birthday: FormatDateToDDMMYYYY(birthday),
            email,
            phone,
            address,
            postal_code: postalCode,
            city,
          })
          .then((data) => {
            checkAuthenticated();
            toast.current.show({
              severity: "success",
              summary: "Succès",
              detail: "Profil mis à jour!",
              life: 3000,
            });
            setRefresh(Date.now());
          })
          .catch((err) => {
            toast.current.show({
              severity: "error",
              summary: "Erreur",
              detail: "Erreur de mise à jour de votre profil utilisateur!",
              life: 3000,
            });
            setRefresh(Date.now());
          });
      },
    });

  };
  //

  const handleUpdatePasswordSubmit = async (e) => {
    e.preventDefault();
    userAPI
      .UpdateUserPassword(
        accessToken,
        oldPassword,
        newPassword,
        confirmPassword
      )
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          detail: "Mot de passe mis à jour!",
          life: 3000,
        });
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setEditPassword(false);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de mise à jour de votre mot de passe!",
          life: 3000,
        });
        setRefresh(Date.now());
      });
  };
  //
  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <MeaPage title="Mon profil utilisateur">
        <div className="grid mb-5 ml-5">
          <div className="col-12 lg:col-3">
            <div className="text-900 font-medium text-xl mb-3">
              Photo de profil
            </div>
            <p className="m-0 p-0 text-400 line-height-2 text-sm mr-3">
              C'est votre photo portrait qui sera visible aux autres membre de
              la plateform.
            </p>
          </div>
          <div className="col-12 lg:col-9">
            <div className="w-full lg:w-6 ">
              <div className="card flex flex-wrap gap-3 p-fluid">
                <Image
                  src={avatar}
                  zoomSrc={avatar}
                  alt="Image"
                  width="60"
                  height="60"
                  imageStyle={{ borderRadius: '50%' }}
                  preview
                />
              </div>
              <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                <div className="card flex mt-3">
                  <ConfirmPopup />
                  <FileUpload
                    mode="basic"
                    name="file"
                    customUpload
                    uploadHandler={async (event) => {
                      await userAPI
                        .UpdateUserAvatar(accessToken, event.files[0])
                        .then((data) => {
                          checkAuthenticated();
                          toast.current.show({
                            severity: "info",
                            summary: "Succès",
                            detail: "Votre photo de profil a été modifiée!",
                            life: 3000,
                          });
                          setRefresh(Date.now());
                        })
                        .catch((err) => {
                          toast.current.show({
                            severity: "error",
                            summary: "Erreur",
                            detail:
                              "Erreur de modification de votre photo de profil!",
                            life: 3000,
                          });
                          setRefresh(Date.now());
                        }).finally(() => {
                          event.options.clear();
                        })
                    }}
                    accept="image/*"
                    maxFileSize={1000000}
                    auto
                    chooseLabel="Modifier"
                  />
                  {account?.avatar && <MeaButton label="Supprimer" outlined className="p-button-danger ml-2" onClick={async (event) => {
                    confirmPopup({
                      target: event.currentTarget,
                      message: 'Voulez-vous vraiment supprimer votre photo de profile?',
                      icon: 'pi pi-exclamation-triangle',
                      defaultFocus: 'accept',
                      rejectLabel: "Non",
                      acceptLabel: "Oui",
                      accept: async () => {
                        await userAPI
                          .DeleteAvatar(accessToken)
                          .then((data) => {
                            checkAuthenticated();
                            toast.current.show({
                              severity: "info",
                              summary: "Succès",
                              detail: "La photo de profil a été supprimée!",
                              life: 3000,
                            });
                            setRefresh(Date.now());
                          })
                          .catch((err) => {
                            toast.current.show({
                              severity: "error",
                              summary: "Erreur",
                              detail:
                                "Erreur de suppression de la photo de profil",
                              life: 3000,
                            });
                            setRefresh(Date.now());
                          });
                      },
                    });
                  }
                  } />}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid mb-5 mt-3 ml-5">
          <div className="col-12 lg:col-3">
            <div className="text-900 font-medium text-xl mb-3">
              Mes informations de base
            </div>
            <p className="m-0 p-0 text-400 line-height-2 text-sm mr-3">
              Nous avons besoin de vos informations de base pour que les autres
              membres de la plateforme vous connaissent.
            </p>
          </div>
          <div className="col-12 lg:col-9">
            <div className="w-full lg:w-6 ">
              <div className="card flex flex-column md:flex-row gap-3 ">
                <div className="p-inputgroup flex-1 flex-column">
                  <label
                    htmlFor="lastname"
                    className="block text-900 font-medium mb-2"
                  >
                    Nom de famille
                  </label>
                  <InputText
                    id="lastname"
                    value={lastname || ""}
                    onChange={(e) => setLastname(e.target.value)}
                    className="w-full mb-1"
                  />
                </div>

                <div className="p-inputgroup flex-1 flex-column">
                  <label
                    htmlFor="firstname"
                    className="block text-900 font-medium mb-2"
                  >
                    Prénom
                  </label>
                  <InputText
                    id="firstname"
                    value={firstname || ""}
                    onChange={(e) => setFirstname(e.target.value)}
                    className="w-full mb-1"
                  />
                </div>
              </div>

              <div className="card flex flex-column md:flex-row gap-3 ">
                <div className="p-inputgroup flex-1 flex-column">
                  <label htmlFor="name" className="block text-900 font-medium mb-2">
                    Nom d'usage
                  </label>
                  <InputText
                    id="name"
                    value={name || ""}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full mb-1"
                  />
                </div>

                <div className="p-inputgroup flex-1 flex-column">
                  <label htmlFor="gender" className="block text-900 font-medium mb-2">
                    Genre
                  </label>
                  <Dropdown
                    id="gender"
                    value={gender || ""}
                    options={[
                      { label: "", value: "N" },
                      { label: "Masculin", value: "B" },
                      { label: "Féminin", value: "G" },
                    ]}
                    onChange={(e) => setGender(e.value)}
                    optionLabel="label"
                    className="w-full mb-1"
                  />
                </div>
              </div>

              <div className="card flex flex-column md:flex-row gap-3 ">
                <div className="p-inputgroup flex-1 flex-column">
                  <label htmlFor="birthday" className="block text-900 font-medium mb-2">
                    Date de naissance
                  </label>
                  <Calendar
                    locale="fr"
                    className="w-full mb-1"
                    value={birthday ? new Date(birthday) : ""}
                    onChange={(e) => setBirthday(e.value)}
                    dateFormat="dd/mm/yy"
                    id="birthday"
                    showIcon
                  />
                </div>
              </div>
              <div className="card flex flex-column md:flex-row gap-3 ">
                <div className="p-inputgroup flex-1 flex-column">
                  <label htmlFor="email" className="block text-900 font-medium mb-2">
                    Email
                  </label>
                  <InputText
                    id="email"
                    value={email || ""}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full mb-1"
                    disabled={true}
                  />
                </div>

                <div className="p-inputgroup flex-1 flex-column">
                  <label htmlFor="phone" className="block text-900 font-medium mb-2">
                    Téléphone
                  </label>
                  <InputText
                    id="phone"
                    value={phone || ""}
                    onChange={(e) => setPhone(e.target.value)}
                    className="w-full mb-1"
                  />
                </div>
              </div>
              <div className="card flex flex-column md:flex-row gap-3 ">
                <div className="p-inputgroup flex-1 flex-column">
                  <label htmlFor="birthday" className="block text-900 font-medium mb-2">
                    Adresse
                  </label>
                  <InputTextarea
                    id="address"
                    className="w-full mb-1"
                    value={address || ""}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
              </div>
              <div className="card flex flex-column md:flex-row gap-3 ">
                <div className="p-inputgroup flex-1 flex-column">
                  <label
                    htmlFor="postalCode"
                    className="block text-900 font-medium mb-2"
                  >
                    Code postale
                  </label>
                  <InputText
                    id="lastname"
                    value={postalCode || ""}
                    onChange={(e) => setPostalCode(e.target.value)}
                    className="w-full mb-1"
                  />
                </div>

                <div className="p-inputgroup flex-1 flex-column">
                  <label
                    htmlFor="city"
                    className="block text-900 font-medium mb-2"
                  >
                    Ville
                  </label>
                  <InputText
                    id="firstname"
                    value={city || ""}
                    onChange={(e) => setCity(e.target.value)}
                    className="w-full mb-1"
                  />
                </div>
              </div>
              <div className="card flex mt-3">
                <MeaButton
                  outlined

                  onClick={handleUpdateProfileSubmit}
                >
                  Enregistrer
                </MeaButton>
              </div>
            </div>
          </div>
        </div>

        <div className="grid mb-5 mt-3 ml-5">
          <div className="col-12 lg:col-3">
            <div className="text-900 font-medium text-xl mb-3">
              Mes informations de connexion
            </div>
            <p className="m-0 p-0 text-400 line-height-2 text-sm mr-3">
              Vous pouvez ici changer votre mot de passe ou activer d'autre
              méthode de connexion à la plateforme.
            </p>
          </div>
          <div className="col-12 lg:col-9">
            <div className="w-full lg:w-6 ">
              <div className="card flex flex-wrap gap-3 p-fluid">
                <div className="flex-auto">
                  <label htmlFor="minmax" className="font-bold block mb-2">
                    Email
                  </label>
                  <InputText
                    className="flex-1 w-full"
                    value={account?.email}
                    disabled
                  //onValueChange={(e) => setValue4(e.value)}
                  />
                  <small id="username-help">
                    C'est aussi votre identifiant de connexion, vous ne pouvez
                    pas le changer!
                  </small>
                </div>
              </div>
              {!editPassword && (
                <div className="card flex flex-wrap gap-3 p-fluid mt-5">
                  <div className="">
                    <MeaButton outlined onClick={() => setEditPassword(true)}>
                      Changer le mot de passe
                    </MeaButton>
                  </div>
                </div>
              )}
              {editPassword && (
                <div className="w-full lg:w-6 mt-5">
                  <div className="card flex flex-wrap gap-3 p-fluid">
                    <div className="flex-auto">
                      <label htmlFor="minmax" className="font-bold block mb-2">
                        Ancien mot de passe
                      </label>
                      <Password
                        className="flex-1 w-full"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        feedback={false}
                        toggleMask
                      />
                    </div>
                  </div>
                  <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                    <div className="flex-auto">
                      <label htmlFor="minmax" className="font-bold block mb-2">
                        Nouveau mot de passe
                      </label>
                      <Password
                        className="flex-1 w-full"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        feedback={false}
                        toggleMask
                      />
                    </div>
                  </div>
                  <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                    <div className="flex-auto">
                      <label htmlFor="minmax" className="font-bold block mb-2">
                        Re-tapez le nouveau mot de passe
                      </label>
                      <Password
                        className="flex-1 w-full"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        feedback={false}
                        toggleMask
                      />
                    </div>
                  </div>
                  <div className="card flex mt-3">
                    <MeaButton
                      disabled={
                        newPassword &&
                          confirmPassword &&
                          newPassword === confirmPassword
                          ? false
                          : true
                      }
                      onClick={handleUpdatePasswordSubmit}
                    >
                      Enregistrer
                    </MeaButton>
                    <MeaButton
                      className="ml-2"
                      outlined
                      onClick={() => {
                        setOldPassword("");
                        setNewPassword("");
                        setConfirmPassword("");
                        setEditPassword(false);
                      }}
                    >
                      Annuler
                    </MeaButton>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <AdminNotificationPreferences
          memberships={account?.memberships}
          toast={toast}
        />
      </MeaPage>
    </>
  );
};
export default UserProfileDetailPage;
